if (!window.Eurus.loadedScript.has('flexible-area.js')) {
  window.Eurus.loadedScript.add('flexible-area.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFlexibleArea', () => ({
        initArea(el) {
          if (!el) return;

          this.adjustFlexWidths(el);

          let resizeTimer;
          window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
              this.adjustFlexWidths(el);
            }, 50);
          });
        },

        adjustFlexWidths(container) {
          if (!container) return;

          const isMobile = window.innerWidth <= 767;

          const items = Array.from(container.children)
            .map((el) => {
              const itemBlock = el.querySelector('.item-block');

              // Если в этом child нет нужного блока — просто пропускаем его
              if (!itemBlock) return null;

              const rawWidth = isMobile
                ? itemBlock.dataset.widthMobile
                : itemBlock.dataset.width;

              const parsedWidth = parseFloat(rawWidth);
              const itemWidth = Number.isFinite(parsedWidth) && parsedWidth > 0 ? parsedWidth : 100;

              return { el, itemWidth };
            })
            .filter(Boolean);

          if (!items.length) return;

          const style = getComputedStyle(container);
          const gap = parseFloat(style.columnGap || style.gap || 0) || 0;
          const containerWidth = container.getBoundingClientRect().width;

          if (!containerWidth) return;

          let currentRow = [];
          let currentTotal = 0;

          items.forEach(({ el, itemWidth }) => {
            if (currentRow.length && currentTotal + itemWidth > 100) {
              this.applyRowWidths(currentRow, gap, containerWidth);
              currentRow = [{ el, itemWidth }];
              currentTotal = itemWidth;
            } else {
              currentRow.push({ el, itemWidth });
              currentTotal += itemWidth;
            }
          });

          this.applyRowWidths(currentRow, gap, containerWidth);
        },

        applyRowWidths(row, gap, containerWidth) {
          if (!row.length || !containerWidth) return;

          const totalGap = gap * (row.length - 1);
          const usableWidth = 100 - (totalGap / containerWidth) * 100;

          row.forEach(({ el, itemWidth }) => {
            el.style.flex = `0 0 ${usableWidth * (itemWidth / 100)}%`;
          });
        }
      }));
    });
  });
}